// crypto.randomUUID() only exists in a secure context (HTTPS, or localhost).
// Local multi-tenant testing runs over plain HTTP on subdomains such as
// http://blc.lvh.me:3000, where window.isSecureContext is false and
// crypto.randomUUID is undefined - calling it throws a TypeError before the
// request is ever sent, which surfaces to the user as a generic failure.
//
// crypto.getRandomValues, unlike randomUUID, is available in insecure
// contexts, so prefer it and only fall back to Math.random where even that
// is missing. These ids are correlation/idempotency keys, not secrets.
export const randomUUID = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = [];
    for (let i = 0; i < 16; i += 1) {
      hex.push(bytes[i].toString(16).padStart(2, "0"));
    }
    return (
      hex.slice(0, 4).join("") +
      "-" +
      hex.slice(4, 6).join("") +
      "-" +
      hex.slice(6, 8).join("") +
      "-" +
      hex.slice(8, 10).join("") +
      "-" +
      hex.slice(10, 16).join("")
    );
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default randomUUID;
